import React, { useState } from 'react';
import { Table, Input, Button, Space, Typography } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';

const { Search } = Input;
const { Title } = Typography;

const CategoryTable = ({ categories, onEdit, onDelete, onAdd, loading }) => {
  const [nameFilter, setNameFilter] = useState('');

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      filteredValue: nameFilter ? [nameFilter] : null,
      onFilter: (value, record) =>
        record.name.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Parent Category',
      dataIndex: 'parentCategoryId',
      key: 'parentCategoryId',
      render: (parentCategoryId, record) => {
        if (!parentCategoryId) return '-';
        const parentCategory = categories.find(cat => cat.id === parentCategoryId);
        return parentCategory ? parentCategory.name : '-';
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
          />
          <Button
            type="link"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete(record)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: '16px', display: 'flex', gap: '16px' }}>
        <Search
          placeholder="Search by name"
          allowClear
          onChange={(e) => setNameFilter(e.target.value)}
          style={{ width: 200 }}
        />
      </div>

      <Table
        columns={columns}
        dataSource={categories}
        rowKey="id"
        loading={loading}
        pagination={{
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          pageSize: 10,
          pageSizeOptions: ['5', '10', '25'],
        }}
      />
    </div>
  );
};

export default CategoryTable;
